import i18next from 'i18next'

const getTranslationMsgCodes = (msgObj) => {
  const missingTranslationStr = 'translationHelper : MISSING TRANSLATION MESSAGE CODE'
  const messageCode = msgObj.messageCode

  if (!messageCode) return missingTranslationStr

  // translate messageData if necessary
  const computedData = msgObj?.messageData?.map(data => {
    if (typeof data === 'number' || typeof data === 'boolean') return data

    return typeof data === 'object'
      ? data?.translate ? i18next.t(data?.value) : data?.value
      : i18next.t(data)
  })

  const translatedCode = i18next.t(`msgCodes:${messageCode}`, computedData)

  // return translations
  return translatedCode
}

export {
  getTranslationMsgCodes
}

/* GENERIC ERRORS */
// t('msgCodes:ITS_BE_ERROR_NOT_FOUND')
// t('msgCodes:ITS_BE_ERROR_NOT_AUTHORIZED')
// t('msgCodes:ITS_BE_ERROR_EXPORT_ERROR')
// t('msgCodes:ITS_BE_ERROR_INVALID_USER_EMAIL')
// t('msgCodes:ITS_BE_ERROR_CANT_EDIT_FIELD')
// t('msgCodes:ITS_BE_ERROR_REQUIRED')
// t('msgCodes:ITS_BE_ERROR_MIN_LENGTH')
// t('msgCodes:ITS_BE_ERROR_MAX_LENGTH')
// t('msgCodes:ITS_BE_ERROR_MISSING_ROUTE_PARAM')


/* ORDERS */
// t('msgCodes:ITS_BE_ERROR_INVALID_ORDER_TYPE')

// Wholesale //
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_ERROR')
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_CUSTOMER_NOT_FOUND')
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_REP_NOT_FOUND')
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_STYLE_NOT_FOUND')


/* DYNAMIC FIELDS */
// t('msgCodes:DYNAMIC_FIELDS.REGION')
